@if (vm$ | async; as vm) {
  <div class="attribute-evolution-container" id="attr-evol-container">
    <!-- Header with back button -->
    <div class="header-section" id="attr-evol-header">
      <app-link (click)="onBackClick()" icon="arrow_back" i18n="@@goBack" id="attr-evol-link-back"
        >Volver</app-link
        >
        <h3 class="page-title" id="attr-evol-title">
          <span i18n="@@trendAnalysis">Análisis de tendencias</span>
        </h3>
      </div>
      <div class="subtitle-section">
        <span i18n="@@attributeVariationDescription">
      A continuación, puede ver la variación de un atributo específico filtrando por atributo y
      período de análisis.
    </span>
        @if (vm.personType === 'PERSON') {
          <span>
            <b i18n="@@document">Documento:</b> {{ documentNumber | cpfMask }}
          </span>
        }
        @if (vm.personType === 'COMPANY') {
          <span id="attr-evol-span-doc-company">
            <b i18n="@@document">Documento:</b> {{ documentNumber | cnpjMask }}
          </span>
        }
      </div>
      <div class="filters-section" id="attr-evol-filters">
        <app-select
          id="attr-evol-select-indicator"
          titleLabel="Atributo para análisis"
          i18n-titleLabel="@@attributeForAnalysis"
          style="min-width: 300px; max-width: 400px; width: 100%"
          [options]="vm.facade.indicators"
          [optionLabelFn]="optionLabelFn"
          [disabled]="vm.isLoading"
          [isLoading]="vm.facade.isLoadingIndicators"
          [loadingText]="loadingIndicatorsText"
          [(ngModel)]="vm.facade.selectedIndicator"
          (ngModelChange)="onIndicatorSelect($event)"
          placeholder="Seleccione un indicador"
          i18n-placeholder="@@selectIndicator"
        ></app-select>
        <app-date-range
          id="attr-evol-daterange-period"
          style="width: 330px"
          [minDate]="vm.dateRange.minDate"
          [maxDate]="vm.dateRange.maxDate"
          [mode]="'monthYear'"
          [disabled]="vm.isLoading"
          titleLabel="Periodo de análisis"
          i18n-titleLabel="@@analysisPeriod"
          [infoLabel]="'MM/AAAA - MM/AAAA'"
          (startDateChange)="onStartDateChange($event)"
          (endDateChange)="onEndDateChange($event)"
        ></app-date-range>
      </div>
      <div class="chart-section" id="attr-evol-chart-section">
        <div class="last-period-container" id="attr-evol-last-period">
          <div id="attr-evol-last-update-wrapper">
            <span i18n="@@dateLastUpdate" id="attr-evol-span-lastupdate"
              >Fecha de última actualización:</span
              >
              <strong id="attr-evol-strong-lastupdate">
                {{ vm.facade.lastProcessingDate || unavailableText }}
              </strong>
            </div>
            <app-icon
              id="attr-evol-icon-help"
              name="help_outlined"
              size="24"
              alt="Help icon"
              i18n-matTooltip
              matTooltip="Los atributos se actualizan semanalmente."
            ></app-icon>
          </div>
          @if (vm.facade.isLoadingChart) {
            <div class="loading-container" id="attr-evol-loading">
              <app-ellipsis-loading id="attr-evol-ellipsis-loading"></app-ellipsis-loading>
            </div>
          }
          @if (vm.hasError) {
            <div class="error-state" id="attr-evol-error-state">
              <img src="assets/images/danger.svg" alt="Error" id="attr-evol-img-error" />
              <span i18n="@@errorRetrievingData" id="attr-evol-span-error"
                >Error al intentar recuperar los datos.</span
                >
              </div>
            } @else {
              @if (!vm.isLoading && vm.facade.chartData.data?.values?.length > 0 && vm.chartOptions) {
                <div
                  class="chart-container"
                  id="attr-evol-chart-container"
                  >
                  <app-chart-cl
                    id="attr-evol-chart"
                    [labels]="vm.facade.chartData.labels"
                    [data]="vm.facade.chartData.data?.values"
                    [type]="'line'"
                    [backgroundColor]="'#42A5F5'"
                    [borderColor]="'#42A5F5'"
                    [borderWidth]="3"
                    [pointRadius]="6"
                    [animationDuration]="1300"
                    [animationEasing]="'easeInOutCubic'"
          [datasetLabel]="
            vm.facade.chartData.data?.label || vm.facade.selectedIndicator?.name || 'Atributo'
          "
                    [customChartOptions]="vm.chartOptions"
                  ></app-chart-cl>
                </div>
              }
              @if (!vm.isLoading && vm.facade.hasSearched && vm.chartDataValues.length === 0) {
                <div
                  class="no-data-container"
                  id="attr-evol-no-data"
                  >
                  <img src="assets/images/warning.svg" alt="Warning" id="attr-evol-img-warning-nodata" />
                  <span i18n="@@noDataDisplay" id="attr-evol-span-nodata">No hay datos para mostrar.</span>
                </div>
              }
              @if (!vm.facade.isLoadingChart && !vm.facade.hasSearched && !vm.canLoadData) {
                <div
                  class="empty-state"
                  id="attr-evol-empty-state"
                  >
                  <img src="assets/images/warning.svg" alt="Warning" id="attr-evol-img-warning-empty" />
                  <span i18n="@@selectAttributeAndPeriod" id="attr-evol-span-empty"
                    >Seleccione un atributo y el período para ver el gráfico.</span
                    >
                  </div>
                }
              }
            </div>
          </div>
        }
